import _slicedToArray from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { StringSplit } from '@tensorflow/tfjs-core';
import { stringSplitImplCPU } from '../kernel_utils/shared';
export function stringSplit(args) {
  var inputs = args.inputs,
      backend = args.backend,
      attrs = args.attrs;
  var skipEmpty = attrs.skipEmpty;
  var input = inputs.input,
      delimiter = inputs.delimiter;

  if (input.dtype !== 'string') {
    throw new Error('Input must be of datatype string');
  }

  if (input.shape.length !== 1) {
    throw new Error("Input must be a vector, got shape: ".concat(input.shape));
  }

  if (delimiter.shape.length !== 0) {
    throw new Error("Delimiter must be a scalar, got shape: ".concat(delimiter.shape));
  }

  var $input = backend.readSync(input.dataId);
  var $delimiter = backend.readSync(delimiter.dataId)[0];

  var _stringSplitImplCPU = stringSplitImplCPU($input, $delimiter, skipEmpty),
      _stringSplitImplCPU2 = _slicedToArray(_stringSplitImplCPU, 3),
      indices = _stringSplitImplCPU2[0],
      values = _stringSplitImplCPU2[1],
      shape = _stringSplitImplCPU2[2];

  var outputSize = values.length;
  return [backend.makeTensorInfo([outputSize, 2], 'int32', indices), backend.makeTensorInfo([outputSize], 'string', values), backend.makeTensorInfo([2], 'int32', new Int32Array(shape))];
}
export var stringSplitConfig = {
  kernelName: StringSplit,
  backendName: 'webgl',
  kernelFunc: stringSplit
};